import { APIEnv, APIResponse } from "../learning/baseInterfaces";
import { getData } from "../learning/global.service";
import { USER_API_CONSTANTS } from "@Constants/api-constants/user/user.constant";

export const getUserInfo = (
  successCB: (res: any | APIResponse) => void,
  errorCB?: (err: any) => void
) => {
  getData(
    USER_API_CONSTANTS.USER_PERSONAL_INFO,
    {},
    null,
    APIEnv.NODE_DASHBOARD
  )
    .then(successCB)
    .catch((error) => {
      if (errorCB) errorCB(error?.response?.data);
    });
};
